import { useState } from 'react';
import { imagePickSize } from 'utils/general';
import clsx from 'clsx';
import Avatar from 'components/Avatar';
import DropdownButton from 'components/Button/DropdownButton/DropdownButton';
import APDropdown from 'components/Dropdown/APDropdown';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import './styles.scss';

const MemberAssignment = ({ members, assignments, onAdd, onRemove }) => {
  const [showOrgMembers, toggleMemberDropdown] = useState(false);

  const show = () => {
    toggleMemberDropdown(true);
  };

  const dismiss = () => {
    toggleMemberDropdown(false);
  };

  const renderAssignmentMenu = () => {
    return (
      <>
        {members.map(member => {
          if (!member.canBeAssigned) return null;
          const isSelected = assignments.some(assignment => assignment.id === member.id);
          const profileImage = member.profileImage ?? null;
          const imagePath = profileImage
            ? `//${process.env.REACT_APP_AWS_CLOUDFRONT}/${imagePickSize(profileImage, 'square60')}`
            : null;
          const displayName = (member.firstname || member.lastname) ?
            [member.firstname, member.lastname].join(' ') :
            member.email;

          return (
            <button
              key={`lead-assignment--${member.id}`}
              className={clsx(
                'ap-dropdown__button',
                'ap-dropdown__button--lead-record-task-assignment',
                'button--unstyled',
                { 'selected': isSelected },
              )}
              onClick={() => onAdd(member)}
            >
              <div className="inline-avatar">
                <div className="inline-avatar__image">
                  <Avatar
                    photo={imagePath}
                    text={!imagePath ? member.initials : null}
                    size={30}
                    borderSize={1}
                  />
                </div>
                <div className="inline-avatar__info">
                  {displayName}
                </div>
              </div>
            </button>
          );
        })}
      </>
    );
  };

  const trigger = (
    <DropdownButton className="button--unstyled button--lead-record-assignment">
      Add
    </DropdownButton>
  );

  return (
    <>
      {assignments.length ? (
        <div className="lead-record-assigned-list">
          {assignments.map(member => {
            const profileImage = member.profileImage ?? null;
            const imagePath = profileImage
              ? `//${process.env.REACT_APP_AWS_CLOUDFRONT}/${imagePickSize(profileImage, 'square60')}`
              : null;

            return (
              <div
                key={member.id}
                className="lead-record-assigned-item"
              >
                <Avatar
                  photo={imagePath}
                  text={!imagePath ? member.initials : null}
                  size={30}
                  borderSize={1}
                />
                <div className="lead-record-assigned-item__name">
                  {member.firstname} {member.lastname}
                </div>
                <div
                  className="lead-record-assigned-item__remove"
                  onClick={() => onRemove(member)}
                >
                  <FontAwesomeIcon
                    icon={['fal', 'times']}
                    size="xs"
                  />
                </div>
              </div>
            );
          })}
        </div>
      ) : null}
      <APDropdown
        isOpen={showOrgMembers}
        show={show}
        dismiss={dismiss}
        triggerButton={trigger}
        placement="bottom-end"
        menuClass="assignment-data-dropdown"
        className="lead-assignments-dropdown"
      >
        {renderAssignmentMenu()}
      </APDropdown>
    </>
  );
};

export default MemberAssignment;
